import styled from '@emotion/styled';
import { settingsTheme as t } from '../theme';

/**
 * Primitivo: píldora con un conteo (por ejemplo, el total de instructores).
 */
const CountBadge = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  background: t.color.countBg,
  color: t.color.countText,
  fontFamily: t.font,
  fontSize: 12.5,
  fontWeight: 600,
  padding: '5px 11px',
  borderRadius: 20,
  whiteSpace: 'nowrap',
});

export default CountBadge;
